import './card.less'

import {DOMAttrs, Picture, StatelessView, classes, m} from '@codeurs/front'

import {Image} from 'types'

type Element = StatelessView<DOMAttrs>

export const Card: Element = ({children, ...attrs}) =>
	m('.card', attrs, children)

export const CardImage: StatelessView<Image> = ({children, ...img}) =>
	img &&
	img.empty === false &&
	m('.cardimage',
		m('.cardimage-picture',
			m(Picture, {
				fit: 'cover',
				...img,
				...classes('cardimage-picture-image')
			})
		),
		children
	)

export const CardContent: Element = ({children, ...attrs}) =>
	m('.cardcontent', attrs, children)

export const CardFooter: Element = ({children, ...attrs}) =>
	m('footer.cardfooter', attrs, children)

export const CardLink: Element = ({children, ...attrs}) =>
	m('a.cardlink', attrs, children)

export const CardTitle: Element = ({children, ...attrs}) =>
	m('.cardtitle', attrs, children)
